import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { semanticColors, greyScaleColors } from '../Globals/styles';

class IncrementInput extends Component {
  componentWillReceiveProps = (nextProps) => {
    if(nextProps.defaultValue > nextProps.maxValue){
      this.props.onChange(nextProps.maxValue)
    }
  }
  decrement = (e) => {
    e.preventDefault(); 
    e.stopPropagation();
    const { minValue, interval, defaultValue, onChange } = this.props;
    let newValue = defaultValue - interval
    
    if(newValue < minValue) {
      return;
    }
    else
        onChange(newValue)
  }
  increment = (e) => {
    e.preventDefault(); 
    e.stopPropagation();
    const { maxValue, interval, defaultValue, onChange } = this.props;
    let newValue = defaultValue + interval
    if( newValue > maxValue) {
      return;
    }
    else
        onChange(newValue)
  }
  render() {
    const {  defaultValue } = this.props;
    return (
      <div className="input-group" style={styles.frame}>
          <span className="input-group-btn">
              <button 
                type="button" 
                className="btn" 
                onTouchEnd={this.decrement} 
                onClick={this.decrement}
                style={{width: 50, touchAction: 'none', backgroundColor: greyScaleColors.greyLighter}}
               >
                <i className="fa fa-caret-left"></i>               
              </button>
          </span>
          <input type="text" style={styles.input} value={defaultValue ? defaultValue : '0'} onChange={()=>{}} readOnly/>
          <span className="input-group-btn">
              <button type="button" className="btn" style={{width: 50,  touchAction: 'none', backgroundColor: greyScaleColors.greyLighter}} onTouchEnd={this.increment} onClick={this.increment}>
                <i className="fa fa-caret-right"></i>               
              </button>
          </span>
      </div>
    );

  }
}

var styles = {
  input: {
    '-webkit-appearance': 'none',  
    border: 'none',
    display: 'block',
    lineHeight: '35px',
    width:' 100%',
    textAlign: 'center',
    cursor: 'pointer',
},
  frame: {
    width: '100%',
    textAlign: 'center',
    cursor: 'pointer',
  },
  slidee: {
    margin: '0',
    padding: '0',
    height: '100%',
    listStyle: 'none',
    color: semanticColors.text
  },
  middleMarker: {
    width: '50px',
    height: '80%',
    marginTop: '2%',
    borderLeft: "1px solid",
    borderRight: "1px solid",
    borderColor: semanticColors.mainBackground,
    position: 'absolute',
    left: '50%',
    marginLeft: '-25px',
    top: '0'
  },
  item: {
    float: 'left',
    margin:'0',
    padding: '0',
    width: '50px',
    height: '100%'
  },
  overlay: {
    position: 'absolute',
    top: '2px',
    left: '0',
    width: '100%',
    height: '35px',
    background: 'linear-gradient(to right, rgba(247,247,247,1) 2%,rgba(247,247,247,1) 6%,rgba(247,247,247,0) 50%,rgba(247,247,247,1) 92%,rgba(255,255,255,1) 200%)'
  },
  active: {
    color: semanticColors.info
  }
}

IncrementInput.defaultProps = {defaultValue: 0};

  IncrementInput.propTypes = {
    minValue: PropTypes.number.isRequired,
    maxValue: PropTypes.number.isRequired,
    interval: PropTypes.number.isRequired,
    defaultValue: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    maxSelectionValue: PropTypes.number,
    overLayColor: PropTypes.string,
    ulStyles: PropTypes.object
  };

export default Radium(IncrementInput);


// WEBPACK FOOTER //
// ./src/App/Common/incrementInput.jsx